// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#edit-guest #btns{
    display:flex;
    justify-content: space-between;
    width:100%;
}

#edit-guest .modal-body{
    font-size: 2.5vh;
}

#edit-guest input{
    display: block;
    border: 0;
    border-bottom: 2px solid rgba(0, 0, 0, .5);
    margin-bottom: 1em;
    outline: none;
    width: 100%;
}

#edit-guest #pin-input{
    display: inline-block;
    width: 4em!important;
    text-align: center!important;
    margin-bottom: .2em!important;
    font-size: 1.2em!important;
}

#edit-guest button{
    border:0;
    padding: .2em;
}

#edit-guest #title{
    font-size: 4vh;
}

#edit-guest #sections{
    position: relative;
    border-bottom: 1px solid black;
    border-left: 1px solid black;
    margin-bottom: 1em;
}

#edit-guest #sections #ospite-btn{
    background: rgba(100, 100, 150, .2);
}

#edit-guest #sections #permessi-btn{
    background: rgba(200, 150, 100, .2);
}

#edit-guest #sections button{
    border:0;
    border-right: 1px solid black;
    outline: none!important;
    padding-left: 1em;
    padding-right: 1em;
    font-size: 2.3vh;
    font-weight: bold;
    color: rgba(10,10,10,.8);
}
#edit-guest #sections .section-selected{
    color:black;
}

#edit-guest label{
    color: rgba(10, 10, 10, .8)!important;
    font-size: 2.3vh!important;
}

#edit-guest label, #edit-guest button, #edit-guest #title{
    font-weight: bold;
}

#edit-guest #pin, #edit-guest #rfid{
    margin-top: 1em;
}

#edit-guest #pin > *, #edit-guest #rfid > * {
    display: block;
    margin: auto;
}

#edit-guest #pin label, #edit-guest #rfid label{
    text-align: center;
}

#edit-guest #pin input {
    border:0;
}

#edit-guest button#cancel-btn{
    box-shadow: 1px 0 5px 0.3px rgba(100,10,10,.5);
    background:rgba(100,0,0,.3);
    color: black!important;
}
#edit-guest button#cancel-btn:hover {
    box-shadow: 1px 0 5px 0.5px rgba(100,10,10,.8);
}
#edit-guest button#save-btn {
    box-shadow: 1px 0 5px 0.3px rgba(10,100,10,.5);
    background:rgba(0,100,0,.3);
    color: black!important;
}
#edit-guest button#save-btn:hover {
    box-shadow: 1px 0 5px 0.5px rgba(10,100,10,.8);
}
#edit-guest button#regenerate-btn {
    box-shadow: 1px 0 5px 0.3px rgba(10,10,100,.5);
    background: rgba(0,0,100,.3);
    color: black!important;
}

#edit-guest #btns button {
    font-size: 2.8vh;
}

#edit-guest .device {
    border:0;
    cursor: pointer;
    -webkit-touch-callout: none;
    /* iOS Safari */
    -webkit-user-select: none;
    /* Safari */
    /* Konqueror HTML */
    /* Old versions of Firefox */
    /* Internet Explorer/Edge */
    user-select: none;
    /* Non-prefixed version, currently
                                    supported by Chrome, Edge, Opera and Firefox */
}

#edit-guest .device-details {
    border: 0;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    box-shadow: 0px 2px 1px 1px rgba(10,10,10,0.4);
    padding: .5em;
}

#edit-guest .device-details button {
    display: block;
    outline:none;
    margin-bottom: .5em;
    color: rgb(40, 40, 40);
    font-size: 2.3vh;
    padding-left: 1em;
    padding-right: 1em;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
}

#edit-guest #device-details-until-btn{
    margin-bottom: 0;
    display: inline-block;
    width: 7em;
}

#edit-guest .device-details input[type=date] {
    display:inline-block;
    width: 7em!important;
    text-align: center;
    border: 0;
}

#edit-guest .device-details #lim-unlim {
    display: flex;
    justify-content: space-between;
}    

#edit-guest .device-details #lim-unlim .selected{
    background: rgba(20, 250, 20, .5);
    border: 1px solid rgba(10, 250, 10, .4);
    box-shadow: 1px 1px 10px 2px rgba(10,250,10,.4);
}    

#edit-guest .device-details #lim-unlim div {
    display: flex;
    justify-content: center;
    border: 1px solid rgba(0, 0, 0, .5);
    width: 100%;
    text-align: center;
    padding: .2em;
}

#edit-guest .device-details #lim-unlim div:first-child {
    border-top-left-radius: 8px;
}
#edit-guest .device-details #lim-unlim div:last-child {
    border-top-right-radius: 8px;
}

#edit-guest .device-details #lim-unlim div > * {
    margin: auto;
}

#edit-guest .device-details #add-permission {
    margin:auto;
    background:rgba(20,250,20,.5);
    box-shadow: 1px 1px 4px 1px rgba(100,250,100.5);
}
#edit-guest .device-details #remove-permission {
    margin: auto;
    background: rgba(240,20,20,.5);
    margin-bottom: 0.5em;
    box-shadow: 1px 1px 4px 1px rgba(250,100,100.5);
}

#edit-guest #guest-details{
    position: relative;
}

#edit-guest .device-details #sms #sms-btn {
    font-size: 2.3vh;
    outline:none;
    border-radius: 0;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    box-shadow: 1px 1px 4px 2px rgba(100,100,250,.5);
    background: rgba(100,100,255,.4);
    margin: auto;
    margin-top: 0.5em;
}

#edit-guest .device-details #sms #sms-btn:focus{
    outline:none;
}

#edit-guest .device-details #sms #sms-btn:disabled{
    color: rgba(0, 0, 0, .5);
    background: rgba(30, 0, 0, .2);
    border: 1px solid rgba(0, 0, 0, 0);
    box-shadow: none;
}

#edit-guest{
    max-width: 800px!important;
}

#edit-guest #sections #elimina-btn{
    position: absolute;
    border-left: 1px solid black;
    right: 0;
    background: rgba(200, 10, 10, 0.5);
}

#edit-guest #rfid select {
    border: 1px solid rgba(30,30,150,.4);
    box-shadow: 0 0 5px 5px rgba(30,30,150,.4);
    border-radius: 8px;
    background: rgba(30,30,150,.3);
    outline: none;
    margin-top: 0.2em;
}

.sharedHost{
    display: block;
    box-shadow: 0 0 2px 2px rgba(255,255,255,.4);
    width: fit-content;
    padding: .2em;
    padding-left: 1em;
    padding-right: 1em;
    border-radius: 20px;
    background: rgba(105, 115, 255, 1);
    color: white;
    margin: auto;
    margin-top: .3em;
}

#addSharedHost{
    box-shadow: 0 0 2px 2px rgba(105, 115, 255, 1);
    width: fit-content;
    margin: auto;
    padding: .5em;
    border-radius: 2px;
    background: rgba(220, 220, 255, .5);
    margin-bottom: 1.5em;
    margin-top: 1em;
}

#addSharedHost input{
    border: 0;
    background: rgba(0, 0, 0, 0);
    outline: none;
    width: 20em;
    padding: .25em;
    color: rgba(65, 75, 215, 1);
}

#addSharedHost button{
    width: 2em;
    height: 2em;
    border: 0;
    color: white;
    background: rgba(105, 115, 255, 1);
    border-radius: 11px;
    font-weight: bold;
    outline: none;
}

.sharedHost button {
    border: 0;
    background: none;
    color: rgba(255, 190, 100, 1);
    font-weight: bold;
    margin-left: .5em;
    font-size: 130%;
    outline: none;
    text-shadow: 1px 0px rgba(155, 90, 0, 1);
}

/* Stili solo per dispositivi con larghezza massima di 600 pixel (tipicamente dispositivi mobili) */
@media only screen and (max-width: 600px) {
    #edit-guest #device-details-until-btn{
        width: 5em!important;
    }
    #edit-guest .device-details label, #edit-guest .device-details button, #edit-guest .device-details input[type=date] {
        font-size: 2vh!important;
    }

    #edit-guest #sections #elimina-btn{
        font-size: 1.5vh;
        bottom: 0;
        height: 100%;
    }
    #addSharedHost input{
        width: inherit!important;
    }
}`, "",{"version":3,"sources":["webpack://./css/modifica_ospite.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,8BAA8B;IAC9B,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,SAAS;IACT,0CAA0C;IAC1C,kBAAkB;IAClB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,4BAA4B;IAC5B,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,QAAQ;IACR,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,QAAQ;IACR,6BAA6B;IAC7B,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;AAC5B;AACA;IACI,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,8CAA8C;IAC9C,2BAA2B;IAC3B,sBAAsB;AAC1B;AACA;IACI,8CAA8C;AAClD;AACA;IACI,8CAA8C;IAC9C,2BAA2B;IAC3B,sBAAsB;AAC1B;AACA;IACI,8CAA8C;AAClD;AACA;IACI,8CAA8C;IAC9C,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,QAAQ;IACR,eAAe;IACf,2BAA2B;IAC3B,eAAe;IACf,yBAAyB;IACzB,WAAW;IAEX,mBAAmB;IAEnB,4BAA4B;IAE5B,2BAA2B;IAC3B,iBAAiB;IACjB;kFAC8E;AAClF;;AAEA;IACI,SAAS;IACT,+BAA+B;IAC/B,8BAA8B;IAC9B,8CAA8C;IAC9C,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,iCAAiC;IACjC,uCAAuC;IACvC,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mCAAmC;IACnC,WAAW;IACX,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,2BAA2B;AAC/B;AACA;IACI,4BAA4B;AAChC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,+CAA+C;AACnD;AACA;IACI,YAAY;IACZ,8BAA8B;IAC9B,oBAAoB;IACpB,+CAA+C;AACnD;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,+BAA+B;IAC/B,8BAA8B;IAC9B,gDAAgD;IAChD,gCAAgC;IAChC,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,QAAQ;IACR,kCAAkC;AACtC;;AAEA;IACI,oCAAoC;IACpC,0CAA0C;IAC1C,kBAAkB;IAClB,8BAA8B;IAC9B,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,4CAA4C;IAC5C,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,kCAAkC;IAClC,YAAY;IACZ,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,8CAA8C;IAC9C,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mCAAmC;IACnC,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,4BAA4B;IAC5B,aAAa;IACb,WAAW;IACX,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,SAAS;IACT,YAAY;IACZ,kCAAkC;IAClC,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,6BAA6B;IAC7B,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,wCAAwC;AAC5C;;AAEA,mGAAmG;AACnG;IACI;QACI,oBAAoB;IACxB;IACA;QACI,wBAAwB;IAC5B;;IAEA;QACI,gBAAgB;QAChB,SAAS;QACT,YAAY;IAChB;IACA;QACI,wBAAwB;IAC5B;AACJ","sourcesContent":["#edit-guest #btns{\n    display:flex;\n    justify-content: space-between;\n    width:100%;\n}\n\n#edit-guest .modal-body{\n    font-size: 2.5vh;\n}\n\n#edit-guest input{\n    display: block;\n    border: 0;\n    border-bottom: 2px solid rgba(0, 0, 0, .5);\n    margin-bottom: 1em;\n    outline: none;\n    width: 100%;\n}\n\n#edit-guest #pin-input{\n    display: inline-block;\n    width: 4em!important;\n    text-align: center!important;\n    margin-bottom: .2em!important;\n    font-size: 1.2em!important;\n}\n\n#edit-guest button{\n    border:0;\n    padding: .2em;\n}\n\n#edit-guest #title{\n    font-size: 4vh;\n}\n\n#edit-guest #sections{\n    position: relative;\n    border-bottom: 1px solid black;\n    border-left: 1px solid black;\n    margin-bottom: 1em;\n}\n\n#edit-guest #sections #ospite-btn{\n    background: rgba(100, 100, 150, .2);\n}\n\n#edit-guest #sections #permessi-btn{\n    background: rgba(200, 150, 100, .2);\n}\n\n#edit-guest #sections button{\n    border:0;\n    border-right: 1px solid black;\n    outline: none!important;\n    padding-left: 1em;\n    padding-right: 1em;\n    font-size: 2.3vh;\n    font-weight: bold;\n    color: rgba(10,10,10,.8);\n}\n#edit-guest #sections .section-selected{\n    color:black;\n}\n\n#edit-guest label{\n    color: rgba(10, 10, 10, .8)!important;\n    font-size: 2.3vh!important;\n}\n\n#edit-guest label, #edit-guest button, #edit-guest #title{\n    font-weight: bold;\n}\n\n#edit-guest #pin, #edit-guest #rfid{\n    margin-top: 1em;\n}\n\n#edit-guest #pin > *, #edit-guest #rfid > * {\n    display: block;\n    margin: auto;\n}\n\n#edit-guest #pin label, #edit-guest #rfid label{\n    text-align: center;\n}\n\n#edit-guest #pin input {\n    border:0;\n}\n\n#edit-guest button#cancel-btn{\n    box-shadow: 1px 0 5px 0.3px rgba(100,10,10,.5);\n    background:rgba(100,0,0,.3);\n    color: black!important;\n}\n#edit-guest button#cancel-btn:hover {\n    box-shadow: 1px 0 5px 0.5px rgba(100,10,10,.8);\n}\n#edit-guest button#save-btn {\n    box-shadow: 1px 0 5px 0.3px rgba(10,100,10,.5);\n    background:rgba(0,100,0,.3);\n    color: black!important;\n}\n#edit-guest button#save-btn:hover {\n    box-shadow: 1px 0 5px 0.5px rgba(10,100,10,.8);\n}\n#edit-guest button#regenerate-btn {\n    box-shadow: 1px 0 5px 0.3px rgba(10,10,100,.5);\n    background: rgba(0,0,100,.3);\n    color: black!important;\n}\n\n#edit-guest #btns button {\n    font-size: 2.8vh;\n}\n\n#edit-guest .device {\n    border:0;\n    cursor: pointer;\n    -webkit-touch-callout: none;\n    /* iOS Safari */\n    -webkit-user-select: none;\n    /* Safari */\n    -khtml-user-select: none;\n    /* Konqueror HTML */\n    -moz-user-select: none;\n    /* Old versions of Firefox */\n    -ms-user-select: none;\n    /* Internet Explorer/Edge */\n    user-select: none;\n    /* Non-prefixed version, currently\n                                    supported by Chrome, Edge, Opera and Firefox */\n}\n\n#edit-guest .device-details {\n    border: 0;\n    border-bottom-right-radius: 8px;\n    border-bottom-left-radius: 8px;\n    box-shadow: 0px 2px 1px 1px rgba(10,10,10,0.4);\n    padding: .5em;\n}\n\n#edit-guest .device-details button {\n    display: block;\n    outline:none;\n    margin-bottom: .5em;\n    color: rgb(40, 40, 40);\n    font-size: 2.3vh;\n    padding-left: 1em;\n    padding-right: 1em;\n    border-top-right-radius: 8px;\n    border-top-left-radius: 8px;\n}\n\n#edit-guest #device-details-until-btn{\n    margin-bottom: 0;\n    display: inline-block;\n    width: 7em;\n}\n\n#edit-guest .device-details input[type=date] {\n    display:inline-block;\n    width: 7em!important;\n    text-align: center;\n    border: 0;\n}\n\n#edit-guest .device-details #lim-unlim {\n    display: flex;\n    justify-content: space-between;\n}    \n\n#edit-guest .device-details #lim-unlim .selected{\n    background: rgba(20, 250, 20, .5);\n    border: 1px solid rgba(10, 250, 10, .4);\n    box-shadow: 1px 1px 10px 2px rgba(10,250,10,.4);\n}    \n\n#edit-guest .device-details #lim-unlim div {\n    display: flex;\n    justify-content: center;\n    border: 1px solid rgba(0, 0, 0, .5);\n    width: 100%;\n    text-align: center;\n    padding: .2em;\n}\n\n#edit-guest .device-details #lim-unlim div:first-child {\n    border-top-left-radius: 8px;\n}\n#edit-guest .device-details #lim-unlim div:last-child {\n    border-top-right-radius: 8px;\n}\n\n#edit-guest .device-details #lim-unlim div > * {\n    margin: auto;\n}\n\n#edit-guest .device-details #add-permission {\n    margin:auto;\n    background:rgba(20,250,20,.5);\n    box-shadow: 1px 1px 4px 1px rgba(100,250,100.5);\n}\n#edit-guest .device-details #remove-permission {\n    margin: auto;\n    background: rgba(240,20,20,.5);\n    margin-bottom: 0.5em;\n    box-shadow: 1px 1px 4px 1px rgba(250,100,100.5);\n}\n\n#edit-guest #guest-details{\n    position: relative;\n}\n\n#edit-guest .device-details #sms #sms-btn {\n    font-size: 2.3vh;\n    outline:none;\n    border-radius: 0;\n    border-bottom-right-radius: 8px;\n    border-bottom-left-radius: 8px;\n    box-shadow: 1px 1px 4px 2px rgba(100,100,250,.5);\n    background: rgba(100,100,255,.4);\n    margin: auto;\n    margin-top: 0.5em;\n}\n\n#edit-guest .device-details #sms #sms-btn:focus{\n    outline:none;\n}\n\n#edit-guest .device-details #sms #sms-btn:disabled{\n    color: rgba(0, 0, 0, .5);\n    background: rgba(30, 0, 0, .2);\n    border: 1px solid rgba(0, 0, 0, 0);\n    box-shadow: none;\n}\n\n#edit-guest{\n    max-width: 800px!important;\n}\n\n#edit-guest #sections #elimina-btn{\n    position: absolute;\n    border-left: 1px solid black;\n    right: 0;\n    background: rgba(200, 10, 10, 0.5);\n}\n\n#edit-guest #rfid select {\n    border: 1px solid rgba(30,30,150,.4);\n    box-shadow: 0 0 5px 5px rgba(30,30,150,.4);\n    border-radius: 8px;\n    background: rgba(30,30,150,.3);\n    outline: none;\n    margin-top: 0.2em;\n}\n\n.sharedHost{\n    display: block;\n    box-shadow: 0 0 2px 2px rgba(255,255,255,.4);\n    width: fit-content;\n    padding: .2em;\n    padding-left: 1em;\n    padding-right: 1em;\n    border-radius: 20px;\n    background: rgba(105, 115, 255, 1);\n    color: white;\n    margin: auto;\n    margin-top: .3em;\n}\n\n#addSharedHost{\n    box-shadow: 0 0 2px 2px rgba(105, 115, 255, 1);\n    width: fit-content;\n    margin: auto;\n    padding: .5em;\n    border-radius: 2px;\n    background: rgba(220, 220, 255, .5);\n    margin-bottom: 1.5em;\n    margin-top: 1em;\n}\n\n#addSharedHost input{\n    border: 0;\n    background: rgba(0, 0, 0, 0);\n    outline: none;\n    width: 20em;\n    padding: .25em;\n    color: rgba(65, 75, 215, 1);\n}\n\n#addSharedHost button{\n    width: 2em;\n    height: 2em;\n    border: 0;\n    color: white;\n    background: rgba(105, 115, 255, 1);\n    border-radius: 11px;\n    font-weight: bold;\n    outline: none;\n}\n\n.sharedHost button {\n    border: 0;\n    background: none;\n    color: rgba(255, 190, 100, 1);\n    font-weight: bold;\n    margin-left: .5em;\n    font-size: 130%;\n    outline: none;\n    text-shadow: 1px 0px rgba(155, 90, 0, 1);\n}\n\n/* Stili solo per dispositivi con larghezza massima di 600 pixel (tipicamente dispositivi mobili) */\n@media only screen and (max-width: 600px) {\n    #edit-guest #device-details-until-btn{\n        width: 5em!important;\n    }\n    #edit-guest .device-details label, #edit-guest .device-details button, #edit-guest .device-details input[type=date] {\n        font-size: 2vh!important;\n    }\n\n    #edit-guest #sections #elimina-btn{\n        font-size: 1.5vh;\n        bottom: 0;\n        height: 100%;\n    }\n    #addSharedHost input{\n        width: inherit!important;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
